import { render } from "./port-fileupload-file-list-wrapper.vue?vue&type=template&id=9ed645a4"
import script from "./port-fileupload-file-list-wrapper.vue?vue&type=script&lang=js"
export * from "./port-fileupload-file-list-wrapper.vue?vue&type=script&lang=js"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__